import { api } from "@/lib/api";

import type {
  CreateResendConnectionReq,
  ResendConnection,
  UpdateResendConnectionReq,
} from "@artisancode/api-types";

export const resendConnectionService = {
  list: () => api.get<ResendConnection[]>("/resend-connections"),
  create: (data: CreateResendConnectionReq) =>
    api.post<ResendConnection>("/resend-connections", data),
  update: (id: string, data: UpdateResendConnectionReq) =>
    api.put<ResendConnection>(`/resend-connections/${id}`, data),
  remove: (id: string) => api.del<null>(`/resend-connections/${id}`),
  setPrimary: (id: string) =>
    api.post<ResendConnection>(`/resend-connections/${id}/primary`, {}),
};
